import React from 'react';

import { HStack, Link, Text, VStack } from '@/components';
import { useTranslation } from '@/hooks';
import { toolsLinks } from '@/statics';

const Tools: React.FC = () => {
  const { t } = useTranslation('components.footer.tools');

  return (
    <>
      <VStack alignItems={'start'} gap={0}>
        <Text
          color="text"
          fontWeight="bold"
          fontSize={'lg'}
          display={'flex'}
          alignItems={'start'}
          justifyContent={'start'}
        >
          {t('tools')}
        </Text>
        <HStack alignItems={'start'} gap={'74'} mt={'30px'}>
          <VStack
            spacing={'20px'}
            justifyContent={'start'}
            alignItems={'start'}
          >
            {toolsLinks.map((data, index) => (
              <Link prefetch={false} key={index} href={data.url || ''}>
                <Text
                  textAlign={'right'}
                  color="text"
                  fontWeight="medium"
                  fontSize={'sm'}
                >
                  {data.title}
                </Text>
              </Link>
            ))}
          </VStack>
        </HStack>
      </VStack>
    </>
  );
};

export default Tools;
